module.exports = __webpack_public_path__ + "about-us-b998e096/500-ec94071fcac0dffa7e92bb3aad86c1f7.svg";